var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuClose = function SvgMenuClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "menu-close_svg__a",
    d: "m8.692 7.984 2.13 2.131a.5.5 0 0 1-.706.708L7.985 8.69l-2.131 2.132a.5.5 0 0 1-.708-.708l2.132-2.13-2.131-2.131a.5.5 0 1 1 .707-.708l2.13 2.131 2.131-2.13a.5.5 0 0 1 .708.707l-2.131 2.13z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#25292D",
    xlinkHref: "#menu-close_svg__a"
  })));
};
export default SvgMenuClose;